import jsPDF from "jspdf";
import html2canvas from "html2canvas";

document.addEventListener("DOMContentLoaded", () => {
	const printButton = document.querySelector(".print-button");
	const pdfButton = document.querySelector(".pdf-button");

	// Print functionality
	if (printButton) {
		printButton.addEventListener("click", () => {
			window.print();
		});
	}

	// PDF export functionality
	if (pdfButton) {
		pdfButton.addEventListener("click", async () => {
			try {
				const pdfTitleElement = document.querySelector(".wp-block-post-title");
				const pdfTitle = pdfTitleElement
					? pdfTitleElement.innerText
					: "Document";
				const printContainer = document.querySelector(".webx-print-container");

				// Clone the print container
				const clonedContainer = printContainer.cloneNode(true);

				// Apply increased font size to the clone
				clonedContainer.style.fontSize = "20px"; // Adjust as needed
				clonedContainer.style.lineHeight = "1.5"; // Optional for better spacing

				// Temporarily add the clone to the DOM (but keep it hidden)
				clonedContainer.style.position = "absolute";
				clonedContainer.style.top = "-9999px";
				clonedContainer.style.left = "-9999px";
				document.body.appendChild(clonedContainer);

				// Render the cloned container to a canvas
				html2canvas(clonedContainer, {
					scale: 2,
					useCORS: true,
					logging: false,
				}).then(function (canvas) {
					// Remove the cloned container from the DOM
					document.body.removeChild(clonedContainer);

					// Convert canvas to an image
					const imgData = canvas.toDataURL("image/jpeg", 0.7); // Use JPEG format for compression

					// Create a PDF instance
					const pdf = new jsPDF("p", "mm", "a4");

					// Calculate dimensions for A4
					const margin = 10;
					const imgWidth = 210 - 2 * margin;
					const imgHeight = (canvas.height * imgWidth) / canvas.width;

					// Add image to PDF
					pdf.addImage(
						imgData,
						"JPEG",
						margin,
						0,
						imgWidth,
						imgHeight,
						undefined,
						"FAST",
					);

					// Save the PDF
					pdf.save(`${pdfTitle}.pdf`);
				});
			} catch (error) {
				console.error("Error generating PDF:", error);
			}
		});
	}
});
